<template>
  <div class="barContainer">
    <div class="content">
      <div class="bar df-between pc-bar">
        <div class="df-start">
          <img class="logo" src="../static/images/navigate/logo.png" alt="" />
          <div class="bar-list df-start">
            <div
              :class="{ active: props.curPage == '' }"
              @click="naviClick('')"
            >
              首页
            </div>
            <div class="bar-dot">●</div>
            <div
              :class="{ active: props.curPage == 'product' }"
              @click="naviClick('product')"
            >
              产品介绍
            </div>
            <div class="bar-dot">●</div>
            <div
              :class="{ active: props.curPage == 'download' }"
              @click="naviClick('download')"
            >
              产品下载
            </div>
            <div class="bar-dot">●</div>
            <div
              :class="{ active: props.curPage == 'about' }"
              @click="naviClick('about')"
            >
              关于我们
            </div>
          </div>
        </div>
        <div class="handle df-end">
          <div class="attention df-center">
            <div class="att-img concatImg">
              <img
                src="../static/images/navigate/icon1.png"
                @click="pcClick('concat')"
                alt=""
              />
            </div>
            <div class="att-img weixinImg">
              <img
                src="../static/images/navigate/icon2.png"
                @click="pcClick('weixin')"
                alt=""
              />
            </div>
            <div class="att-img miniImg">
              <img
                src="../static/images/navigate/icon3.png"
                @click="pcClick('mini')"
                alt=""
              />
            </div>
            <div class="pc-pop concat">
              <!-- <div class="round-triangle"></div> -->
              <div class="pcPop-content">
                <img src="../static/images/qrcode.jpg" alt="" />
                <div class="pcPop-text">扫码关注公众号</div>
              </div>
            </div>
            <div class="pc-pop weixin">
              <div class="pcPop-content">
                <img src="../static/images/concatCode.png" alt="" />
                <div class="pcPop-text">扫码添加微信</div>
              </div>
            </div>
            <div class="pc-pop mini">
              <div class="pcPop-content">
                <img src="../static/images/miniCode.jpg" alt="" />
                <div class="pcPop-text">扫码进入小程序</div>
              </div>
            </div>
            <!-- <div class="pop"></div> -->
          </div>

          <!-- <div class="handle-box df-end">
            <div class="handle-left">
              <a href="https://dt-visual.bolineyecare.com/">登录</a>
            </div>
            <div class="handle-left">
              <a href="https://dt-visual.bolineyecare.com/?uiType=30010"
                >注册</a
              >
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="bar mob-bar">
      <div class="df-between h44">
        <div class="more-box">
          <img
            class="more"
            @click="mobileClick('navigate')"
            src="../static/images/navigate/more.png"
            alt=""
          />
        </div>

        <img class="mob-logo" src="../static/images/navigate/logo.png" alt="" />
        <div class="handle df-start">
          <img
            class="hansle-icon"
            src="../static/images/navigate/icon-mob1.png"
            alt=""
            @click="mobileClick('concat')"
          />
          <img
            class="hansle-icon"
            src="../static/images/navigate/icon-mob2.png"
            alt=""
            @click="mobileClick('weixin')"
          />
          <img
            class="hansle-icon"
            src="../static/images/navigate/icon-mob3.png"
            alt=""
            @click="mobileClick('mini')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineEmits, defineProps } from "vue";
const emit = defineEmits(["changeType", "changePage"]);
const props = defineProps(["curPage"]);
const type = ref("");
const mobileClick = (type) => {
  emit("changeType", type);
};
const pcClick = (type1) => {
  type.value = type1;
};
const naviClick = (page) => {
  emit("changePage", page);
};
</script>
<style lang="scss">
@import "@/style/main.scss";
@import "@/style/common.scss";
.barContainer {
  width: 100%;
  height: 91px;
  // padding: 0 200px;
  box-sizing: border-box;
  font-size: 18px;
  color: #4c4f5e;
  position: relative;
  .bar-dot {
    font-size: 10px;
  }
  .pc-pop {
    display: none;
    position: absolute;
    top: 40px;
    width: 132px;
    height: 156px;
    background: url("../static/images/navigate/pop-bg.png");
    background-size: 132px 156px;
    // border-radius: 10px;
    text-align: center;
    z-index: 99;

    .pcPop-content {
      position: relative;
      > img {
        width: 80px;
        height: 80px;
        margin-bottom: 5px;
        margin-top: 30px;
      }
      .pcPop-text {
        font-size: 10px;
      }
      // &::before {
      //   content: "";
      //   position: absolute;
      //   top: -20px;
      //   left: 40px;
      //   width: 0;
      //   height: 0;
      //   border: 10px solid;
      //   border-left-color: transparent;
      //   border-right-color: transparent;
      //   border-top-color: transparent;
      //   border-bottom-color: #fff;
      // }
    }
  }
  .concat {
    right: 50px;
    &:hover {
      display: block;
    }
  }
  .weixin {
    right: 10px;
    &:hover {
      display: block;
    }
  }
  .mini {
    right: -30px;
    &:hover {
      display: block;
    }
  }
}
.bar {
  height: 90px;
  margin: 0 auto;
  border-bottom: 1px solid #4d77ff;
}
.mob-bar {
  .h44 {
    .mob-logo {
      width: 113px;
    }
  }
}
.logo {
  width: 120px;
  margin-right: 72px;
}
.bar-list {
  cursor: pointer;
}
.attention {
  width: 152px;
  height: 48px;
  border-radius: 24px;
  background-color: $mainColor;
  cursor: pointer;
  position: relative;
  .att-img > img {
    width: 32px;
    height: 32px;
    margin: 10px 5px;
  }
  // > img:hover + .concat {
  //   display: block;
  //   background-color: red;
  // }
  .concatImg {
    &:hover ~ .concat {
      display: block;
    }
  }
  .weixinImg {
    &:hover ~ .weixin {
      display: block;
    }
  }
  .miniImg {
    &:hover ~ .mini {
      display: block;
    }
  }
  .pop {
    position: absolute;
    bottom: -121px;
    left: 10px;
    width: 104px;
    height: 121px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 16px 2px #4d77ff;
    z-index: 999;
  }
}
.active {
  color: $mainColor;
  font-weight: bold;
}
.more-box {
  width: 84px;
}
.handle-box {
  color: $mainColor;
  font-weight: bold;
}
.handle-left {
  margin-left: 16px;
  > a {
    color: $mainColor;
  }
}
.bar-dot {
  margin: 0 32px;
}
.hansle-icon {
  margin-right: 8px;
  width: 40px;
  height: 40px;
}
</style>